export default __webpack_public_path__ + "static/media/openReports.9881d412.svg";